'use client';

import GtagService from '@/services/Gtag.service';
import Image from 'next/image';
import icoTelegram from '@/public/images/telegram_logo.svg';

function sendTelegramTracking() {
  GtagService.customEvent(`telegram_invite_group`, { category: `click`, type: `footer` });
}
export default function LinkGrupoTelegram() {
  return (
    <a onClick={sendTelegramTracking} href="https://t.me/oamarelinho" target="_blank" rel="noreferrer">
      <div className="footer-whatsapp-header">
        <Image width={25} height={25} src={icoTelegram} alt="Telegram" />
        <div className="container">
          <p>Clique aqui para entrar no grupo do Telegram </p>
        </div>
      </div>
    </a>
  );
}
